import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import ModalCloseIcon from "../../common/Components/Icons/ModalCloseIcon";
import AddOrEditWeaveTypeForm from "./AddOrEditWeaveTypeForm";
const WeaveTypeModal = (props: any) => {
  const { openModal, closeModal, editData, getAllData, handleName, form } =
    props;

  return (
    <Modal
      isOpen={openModal}
      toggle={closeModal}
      size="lg"
      fade={false}
      className="WeaveTypeModal"
    >
      <ModalHeader>
        <div className="Heading">
          <h3>Add New Weave Type</h3>
          <ModalCloseIcon {...props} closeModal={closeModal} />
        </div>
      </ModalHeader>
      <ModalBody>
        <AddOrEditWeaveTypeForm
          {...props}
          closeModal={closeModal}
          editData={editData}
          getAllData={getAllData}
          handleName={handleName}
          form={form}
        />
      </ModalBody>
    </Modal>
  );
};

export default WeaveTypeModal;
